import { FormattedMessage } from 'react-intl';

import { Button } from 'atoms/buttons/Button';
import { ANY_SPORT_MARKET_WHEEL } from 'constants/__generated__/routes';
import { useSportContext } from 'contexts/sport';
import { useFeatureFlags } from 'hooks/useFeatureFlags';

type Props = {
  nbTickets?: number;
  children?: React.ReactNode;
  onClick?: () => void;
};

export const SecondaryOrTickets = ({
  nbTickets = 2,
  children,
  onClick,
}: Props): React.ReactNode => {
  const { sport, generateSportContextPath } = useSportContext();
  const {
    flags: {
      marketDailyWheelBySportAndRarity = {
        baseball: { limited: false, common: false },
        football: { limited: false, common: false },
        nba: { limited: false, common: false },
      },
    },
  } = useFeatureFlags();
  if (!marketDailyWheelBySportAndRarity[sport.toLowerCase()]?.limited) {
    return children;
  }

  return (
    <Button
      to={generateSportContextPath(ANY_SPORT_MARKET_WHEEL)}
      color="transparent"
      fullWidth
      size="medium"
      onClick={onClick}
    >
      <FormattedMessage
        id="Wheel.Cta.GoSpinNow"
        defaultMessage="{nbTickets, plural, one {+1 Wheel Ticket!} other {+# Wheel Tickets!}} Go Spin Now!"
        values={{
          nbTickets,
        }}
      />
    </Button>
  );
};
